import axios from "../index.js"

var basic = {
    // 获取列表
	getFilterRows: function (data, success, failure) {
		return axios.post("/api/v2/open/worksheet/getFilterRows", data, success, failure);
	},
	// 选项集
	getOptionSets: function (data, success, failure) {
		return axios.post("/api/v1/open/app/getOptionSets", data, success, failure);
	},
	// 获取列表总行数
	getFilterRowsTotalNum: function (data, success, failure) {
		return axios.post("/api/v2/open/worksheet/getFilterRowsTotalNum", data, success, failure);
	},
}
export default basic


// WEBPACK FOOTER //
// ./src/api/url/basic.js